import { PlayerProfileDoc } from '@/features/player/components/types';
import { getPlayer } from '@/libs/firebase/firestore/firestore-helpers';

export async function fetchPlayerProfile(playerId: string) {
  return await getPlayer<PlayerProfileDoc>(playerId);
}
